import { Modal } from '@trussworks/react-uswds';
import { ModalHeader } from '.';
import useListener from '@src/customHooks/useListener';
import classNames from 'classnames';
import { useModal } from '@stores';

const sizeMap = {
  sm: false,
  md: true,
  lg: true,
};

const ModalContent = ({ children, className = '', hasCloseButton = false, size = 'lg', title, ...customProps }) => {
  const { closeModal } = useModal();
  const modalClasses = classNames(className, {
    'modal-md': size === 'md',
  });

  useListener('keydown', (e) => {
    if (hasCloseButton && (e.key === 'Esc' || e.key === 'Escape')) {
      closeModal();
    }
  });

  useListener('click', (e) => {
    const isOverlayClick = e.target.getAttribute('data-testId') === 'modalOverlay';
    const isCloseBtnClick = e.target.getAttribute('data-close-modal') === 'true';
    const isPrimaryModal = !!e.target?.closest('[role=dialog]')?.querySelector('[data-primary-modal]');

    if (isPrimaryModal && hasCloseButton && (isOverlayClick || isCloseBtnClick)) {
      closeModal();
    }
  });

  return (
    <Modal
      aria-describedby='primary-modal-content'
      aria-labelledby='primary-modal-header'
      className={modalClasses}
      data-primary-modal='true'
      forceAction={!hasCloseButton}
      isInitiallyOpen
      isLarge={sizeMap[size || 'lg']}
      {...customProps}
    >
      <ModalHeader title={title} />
      <div id='primary-modal-content' className='primary-modal-content'>
        {children}
      </div>
    </Modal>
  );
};

export default ModalContent;
